var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 30,
    fill: "#EBF2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7497 38.125H27.583V59.625H34.7497V38.125Z",
    stroke: "#8AAF45",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.667 36.3334C55.5181 36.3334 58.2524 37.466 60.2684 39.482C62.2844 41.498 63.417 44.2323 63.417 47.0834V59.625H56.2503V47.0834C56.2503 46.133 55.8728 45.2216 55.2008 44.5496C54.5288 43.8776 53.6174 43.5 52.667 43.5C51.7166 43.5 50.8052 43.8776 50.1332 44.5496C49.4612 45.2216 49.0837 46.133 49.0837 47.0834V59.625H41.917V47.0834C41.917 44.2323 43.0496 41.498 45.0656 39.482C47.0816 37.466 49.8159 36.3334 52.667 36.3334V36.3334Z",
    stroke: "#8AAF45",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1663 32.75C33.1454 32.75 34.7497 31.1457 34.7497 29.1667C34.7497 27.1877 33.1454 25.5834 31.1663 25.5834C29.1873 25.5834 27.583 27.1877 27.583 29.1667C27.583 31.1457 29.1873 32.75 31.1663 32.75Z",
    stroke: "#8AAF45",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.8138c8a0fcdc26d710a1caf3f1c4c9b0.svg";
export { ForwardRef as ReactComponent };